import M6Detail from './M6Detail';

export default M6Detail;
